import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/Filter/FilterAnatomy.mdx";
import Usage from "../../Docs/Components/Filter/FilterUsage.mdx";

import Examples from "../../Docs/Components/Filter/FilterExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Filter"
            description="A multi-level filter component optimized for small screen experiences."
            apiSources={["azure-devops-ui/Components/Filter/Filter.Props.d.ts", "azure-devops-ui/Components/FilterBar/FilterBar.Props.d.ts", "azure-devops-ui/Components/FilterBarItem/FilterBarItem.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;